import { isDefined } from './is-defined';
export function getFilteredProperties(properties, filter, omitFields) {
    if (!isDefined(properties))
        return {};
    const filteredFormSchema = Object.entries(properties).reduce((acc, [property, definition]) => {
        if (!(omitFields === null || omitFields === void 0 ? void 0 : omitFields.includes(property))) {
            if (definition['type'] === 'object' && 'properties' in definition) {
                const subFilteredSchema = getFilteredProperties(definition['properties'], filter);
                if (subFilteredSchema && Object.keys(subFilteredSchema).length > 0) {
                    acc[property] = Object.assign(Object.assign({}, definition), { properties: subFilteredSchema });
                }
            }
            else if (property.toLowerCase().includes(filter)) {
                acc[property] = definition;
            }
        }
        return acc;
    }, {});
    return filteredFormSchema;
}
//# sourceMappingURL=get-filtered-properties.js.map